import { useApi } from '@/api';
import {
  ChartSkeleton,
  KpiCard,
  KpiEntityName,
  KpiSkeleton
} from '@/components';
import { tokensMapping } from '@/utils/tokens';
import { CryptoIcon, Flex } from '@blockanalitica/ui';
import HistoricTabs from './HistoricTabs';

export default function OverviewKpis({ daysAgo }) {
  const [data, error] = useApi({
    url: '/groups/overall/',
    queryParams: {
      days_ago: daysAgo
    }
  });

  const [overallData, overallError] = useApi({
    url: '/overall/',
    queryParams: {
      days_ago: daysAgo
    }
  });

  if (error || overallError) {
    throw error;
  }
  if (data && overallData) {
    return (
      <>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            title="Total Debt"
            variant="usds"
            data={data}
            field="debt"
            options={{
              prefixIcon: (
                <KpiEntityName
                  symbol2={
                    <CryptoIcon
                      name="DAI"
                      address={tokensMapping('DAI').address}
                      size="3"
                    />
                  }
                  symbol1={
                    <CryptoIcon
                      name="USDS"
                      address={tokensMapping('USDS').address}
                      size="3"
                    />
                  }></KpiEntityName>
              )
            }}
          />
          <KpiCard
            title="Total Collateral"
            data={overallData}
            field="total_collateral"
            options={{
              currency: 'USD'
            }}
          />
          <KpiCard
            title="Collateralization Ratio"
            data={data}
            field="collateral_ratio"
            options={{
              percentage: true,
              variants: { valuePercentageValue: 'dynamic' }
            }}
          />
        </Flex>
        <HistoricTabs />
      </>
    );
  }

  return (
    <>
      <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
        <KpiSkeleton />
        <KpiSkeleton />
      </Flex>
      <ChartSkeleton />
    </>
  );
}
